<template>
  <div v-if="dataPermission && dataPermission.includes('CNPS_CSS_QR_UPLOAD_IMAGE_WEB')">
    <div class="breadcrumb-area pos-relative w-100">
      <h1 style="font-size: 18px; font-weight: 500">
        Cập nhật dán
        <span class="font-weight-bold" style="font-size: 19px">Sticker QR</span>
      </h1>
      <div class="float-right">
        <b-link
          class="font-medium f12 btn btn-outline-primary m-r-10"
          @click="updateSticker"
          :disabled="!hasChanges || isLoading"
        >
          <b-icon icon="check-lg" aria-hidden="true" />
          Cập nhật
        </b-link>
        <button
          type="button"
          @click="handleCancel()"
          class="font-medium f12 btn btn-outline-secondary m-r-10"
        >
          <b-icon icon="arrow-left" aria-hidden="true" />
          Huỷ bỏ
        </button>
      </div>
      <hr />
    </div>

    <b-row class="gx-4 px-20">
      <!-- Box 1: Thông tin chung -->
      <b-col cols="6" md="6">
        <b-card class="shadow-card mb-3">
          <p style="font-size: 16px !important; font-weight: 400 !important; padding-bottom: 10px">
            Thông tin merchant
          </p>
          <template v-if="!isLoading">
            <!-- Hiển thị tất cả các thông tin trừ các danh sách -->

            <div class="form-group form-row pl-2">
              <label for="" class="col-sm-4 col-form-label"
                >Tên marchant <span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <b-link
                  size="sm"
                  :href="`/customer-support/account/${info?.merchantAccountInfo?.id}`"
                  target="_blank"
                  class="form-control-plaintext f12 text-primary font-weight-bold"
                  >{{ info?.merchantAccountInfo?.name || '' }}</b-link
                >
              </div>
            </div>
            <div class="form-group form-row pl-2">
              <label for="" class="col-sm-4 col-form-label"
                >Email <span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <a
                  class="form-control-plaintext f12 text-primary"
                  :href="`mailto:${info?.merchantAccountInfo?.email}`"
                  >{{ info?.merchantAccountInfo?.email || '' }}</a
                >
              </div>
            </div>
            <div class="form-group form-row pl-2">
              <label for="" class="col-sm-4 col-form-label"
                >Địa chỉ <span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ info?.merchantAccountInfo?.businessRegistrationAddress || '' }}
                </p>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="spinner-center">
              <b-spinner class="align-middle" />
            </div>
          </template>
        </b-card>
        <b-card class="shadow-card h-mo">
          <p style="font-size: 16px !important; font-weight: 400 !important; padding-bottom: 10px">
            Thông tin
            <span style="font-size: 17px; font-weight: 700">Sticker QR</span>
          </p>
          <template v-if="!isLoading">
            <!-- Hiển thị tất cả các thông tin trừ các danh sách -->
            <div
              class="form-group form-row pl-2"
              v-for="(value, key) in formattedInfoSticker"
              :key="key"
            >
              <label for="" class="col-sm-4 col-form-label"
                >{{ key }} <span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ value }}</p>
              </div>
            </div>
            <div class="form-group form-row pl-2" v-if="info.status">
              <label for="" class="col-sm-4 col-form-label"
                >Trạng thái <span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <!-- <b-badge class="mt-1" >{{
                  getNameStatus
                }}</b-badge> -->
                <b-form-group class="mt-1" label="Chọn trạng thái mới:">
                  <b-form-select
                    v-model="newStatus"
                    :options="optionStatus"
                    text-field="text"
                    value-field="id"
                    size="sm"
                  >
                  </b-form-select>
                </b-form-group>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="spinner-center">
              <b-spinner class="align-middle" />
            </div>
          </template>
        </b-card>
      </b-col>
      <b-col cols="6" class="pl-0" md="6">
        <b-card class="shadow-card mb-3 h-mo" v-loading="isLoading">
          <p style="font-size: 16px !important; font-weight: 400 !important; padding-bottom: 10px">
            Thông tin dán
            <span style="font-size: 17px; font-weight: 700">Sticker QR</span>
          </p>
          <div class="info-content">
            <div class="image-section">
              <div class="image-row">
                <div class="image-container mb-4">
                  <UploadOneOrMultip
                    :maxFile="100"
                    title="Sticker QR cận cảnh"
                    :uploadToApi="false"
                    :isDragging="true"
                    titleTag="label"
                    :single-file="true"
                    ref="uploadImages1"
                    titleClass="label-uploadd"
                  />
                </div>
              </div>
              <div class="image-row">
                <div class="image-container mb-4">
                  <UploadOneOrMultip
                    :maxFile="100"
                    title="Sticker QR ở quầy bán hàng"
                    :uploadToApi="false"
                    :isDragging="true"
                    titleTag="label"
                    :single-file="true"
                    ref="uploadImages2"
                    titleClass="label-uploadd"
                  />
                </div>
              </div>
              <div class="image-row">
                <div class="image-container mb-4">
                  <UploadOneOrMultip
                    :maxFile="100"
                    title="Ảnh màn hình GD thành công"
                    :uploadToApi="false"
                    :isDragging="true"
                    titleTag="label"
                    :single-file="true"
                    ref="uploadImages3"
                    titleClass="label-uploadd"
                  />
                </div>
              </div>
              <div class="image-row">
                <div class="image-container mb-4">
                  <UploadOneOrMultip
                    :maxFile="100"
                    title="Ảnh Tingbox"
                    :uploadToApi="false"
                    :isDragging="true"
                    titleTag="label"
                    :single-file="true"
                    ref="uploadImages4"
                    titleClass="label-uploadd"
                  />
                </div>
              </div>
            </div>
            <div class="info-row image-row">
              <label>Ghi chú:</label>
              <b-form-textarea
                id="textarea"
                v-model="note"
                placeholder="Vui lòng nhập ghi chú"
                rows="4"
                max-rows="6"
              >
                {{ note || '' }}
              </b-form-textarea>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import { showMess } from '@/config/utils'
  import { CommonService } from '@/services/common.service'
  import { UpdateSticker, DetailSticker } from '@/services/customer-support/account'

  import moment from 'moment'
  import UploadOneOrMultip from '@/components/cskh/UploadOneOrMultip.vue'

  export default {
    components: {
      UploadOneOrMultip,
    },
    data() {
      return {
        moList: [],
        maList: [],
        storeList: [],
        isLoading: true,
        mappingLabel: [],
        mappingStatus: [],
        id: '',
        info: {},
        infoDefault: {},
        newStatus: '',
        note: '',
        isLoadingUpdate: false,
        hasAnyChanges: false,
      }
    },

    created() {
      this.id = this.$router.currentRoute.params.id
    },

    async mounted() {
      if (this.dataPermission && this.dataPermission.includes('CNPS_CSS_QR_UPLOAD_IMAGE_WEB')) {
        await this.configSystem()
        await this.loadData()
      } else {
        this.$bvModal
          .msgBoxOk('Bạn không có quyền truy cập vào trang này', {
            title: 'Cảnh báo',
            okVariant: 'danger',
            headerClass: 'p-2 border-bottom-0',
            footerClass: 'p-2 border-top-0',
            centered: true,
          })
          .then(() => {
            this.$router.replace('/')
          })
      }
      this.checkChanges()
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      hasChanges() {
        if (this.info.status !== this.newStatus || this.info.note !== this.note || this.isLoading) {
          return true
        }
        const image1 = this.$refs.uploadImages1?.getData() || []
        const image2 = this.$refs.uploadImages2?.getData() || []
        const image3 = this.$refs.uploadImages3?.getData() || []
        const image4 = this.$refs.uploadImages4?.getData() || []

        const originalImages = {
          image1: this.info?.images?.find(img => img.type === 1)?.linkUrl || '',
          image2: this.info?.images?.find(img => img.type === 2)?.linkUrl || '',
          image3: this.info?.images?.find(img => img.type === 3)?.linkUrl || '',
          image4: this.info?.images?.find(img => img.type === 4)?.linkUrl || '',
        }

        const newImages = {
          image1: image1[0]?.url || '',
          image2: image2[0]?.url || '',
          image3: image3[0]?.url || '',
          image4: image4[0]?.url || '',
        }

        return (
          newImages.image1 !== originalImages.image1 ||
          newImages.image2 !== originalImages.image2 ||
          newImages.image3 !== originalImages.image3 ||
          newImages.image4 !== originalImages.image4
        )
      },
      listImages() {
        return this.mappingLabel.map(i => {
          const dataImage = this.info?.images?.filter(
            item => Number(item.type) === Number(i.type)
          )[0]
          return {
            ...i,
            label: i.name,
            ...dataImage,
            url: dataImage?.linkUrl,
          }
        })
      },

      formattedInfoSticker() {
        return {
          'Ngân hàng': this.info.bankCode,
          'Tên tài khoản': this.info.name,
          'Mobile User': this.info.mobileUserName,
          'Số tài khoản': this.info.bankAccountNumber,
          'Ngày in': this.info.lastModifiedPrinted
            ? this.formatDate(this.info.lastModifiedPrinted)
            : '',
          'Ngày dán': this.info.lastModifiedPasted
            ? this.formatDate(this.info.lastModifiedPasted)
            : '',
          'Ngày huỷ': this.info.lastModifiedStop ? this.formatDate(this.info.lastModifiedStop) : '',
        }
      },

      optionStatus() {
        return this.mappingStatus.map(i => {
          return {
            id: i.code,
            text: i.name,
            value: i.code,
          }
        })
      },
    },

    methods: {
      async configSystem() {
        try {
          const res = await CommonService.getConfigSystem()
          this.moList = res.data?.moContact
          this.maList = res.data?.maContact
          this.storeList = res.data?.storeContact
          this.mappingLabel = res.data?.imageQRType
          this.mappingStatus = res.data?.qrStatus
        } catch (e) {
          showMess(
            this,
            'Error',
            e.response?.data?.message || e.response?.message || e.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        }
      },

      async handleCancel() {
        if (this.hasChanges) {
          const confirm = await this.$bvModal.msgBoxConfirm('Bạn có chắc muốn huỷ các thay đổi?', {
            title: 'Xác nhận',
            okVariant: 'danger',
            okTitle: 'Đồng ý',
            cancelTitle: 'Huỷ',
            hideHeaderClose: false,
            centered: true,
          })

          if (confirm) {
            this.$router.push(`/customer-support/account-qr`)
          }
        } else {
          this.$router.push(`/customer-support/account-qr`)
        }
      },
      async updateSticker() {
        this.isLoadingUpdate = true
        try {
          const image1 = await this.$refs.uploadImages1.saveData()
          const image2 = await this.$refs.uploadImages2.saveData()
          const image3 = await this.$refs.uploadImages3.saveData()
          const image4 = await this.$refs.uploadImages4.saveData()

          // Hàm chuyển đổi format ảnh
          const getImageData = (imageData, type) => {
            if (imageData[0]?.urlImage) {
              return {
                linkUrl: imageData[0].urlImage,
                type,
              }
            }
            return null
          }

          // Lọc bỏ các phần tử null
          const images = [
            getImageData(image1, 1),
            getImageData(image2, 2),
            getImageData(image3, 3),
            getImageData(image4, 4),
          ].filter(item => item !== null)

          // Validate ảnh loại 1 khi trạng thái là PASTED_QR
          if (this.newStatus === 'PASTED_QR' && !images.some(img => img.type === 1)) {
            showMess(
              this,
              'Error',
              'Ảnh loại 1 là bắt buộc khi trạng thái dán',
              'danger',
              'b-toaster-top-right',
              5 * 60 * 60
            )
            return
          }

          const payload = {
            id: this.id,
            status: this.newStatus,
            note: this.note || this.info.note,
            images: images,
          }

          const res = await UpdateSticker(payload)
          if (res.code === 1000) {
            const modal = this.showSuccessMx(res.message)
            modal.then(() => {
              this.$router.push('/customer-support/account-qr')
            })
          }
          if (!res.result) {
            showMess(this, 'Error', res.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
          }
        } catch (e) {
          showMess(
            this,
            'Error',
            e.response?.data?.message || e.response?.message || e.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        } finally {
          this.isLoadingUpdate = false
        }
      },

      formatDate(date, format = 'HH:mm, DD/MM/YYYY') {
        if (!date) return
        return moment(date).format(format)
      },
      async loadData() {
        try {
          this.isLoading = true
          const res = await DetailSticker(this.id)
          if (res.code === 1000) {
            this.info = res.data
            this.newStatus = res.data?.status
            this.note = res.data?.note
            this.infoDefault = this?.info
            const formattedImages =
              res.data?.images?.map(imgObj => ({
                url: imgObj.linkUrl || '',
                location: imgObj.location || '',
                type: imgObj.type || 'images',
                uploaded: false,
              })) || []
            const imagesForType1 = formattedImages.filter(img => img.type === 1)
            const imagesForType2 = formattedImages.filter(img => img.type === 2)
            const imagesForType3 = formattedImages.filter(img => img.type === 3)
            const imagesForType4 = formattedImages.filter(img => img.type === 4)
            this.$refs.uploadImages1.setData(imagesForType1)
            this.$refs.uploadImages2.setData(imagesForType2)
            this.$refs.uploadImages3.setData(imagesForType3)
            this.$refs.uploadImages4.setData(imagesForType4)
          }
        } catch (e) {
          showMess(
            this,
            'Lỗi',
            e.response?.data?.message || e.response?.message || e.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        } finally {
          this.isLoading = false
        }
      },
      formatTextSearch(text) {
        return text ? text.split(' ').join(', ') : ''
      },
    },
  }
</script>
<style lang="scss" scoped>
  .breadcrumb {
    margin-bottom: 0;
  }
  .h-fit {
    height: fit-content !important;
  }
  .image-section {
    display: flex;
    flex-wrap: wrap;
    .image-row {
      width: 50%;
      display: flex;
      flex-direction: column;
      gap: 8px;
      label {
        color: black;
        font-weight: 600 !important;
        .image-container {
          width: 100%;
          border-radius: 4px;
          img {
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
          }
        }
      }
    }
  }
  .label-uploadd {
    font-size: 14px !important;
    font-weight: 600 !important;
  }
  label {
    color: black;
    font-weight: 600;
  }

  .image-placeholder {
    color: #999;
    font-size: 13px;
    font-weight: 300;
  }

  .shadow-card {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    border: 0.1px solid #e4e4e4;
  }
  .min-h-290 {
    min-height: 290px;
  }
  .h-mo {
    min-height: 430px;
  }
  .h-mo.b-table-sticky-header {
    max-height: 36.5svh !important;
  }
  .card-footer {
    background-color: #fff;
    border-top: none !important;
  }
  .b-table-sticky-header {
    min-height: 29.5svh;
    max-height: 29.5svh;
  }

  .card-title {
    font-size: 16px !important;
    font-weight: bold;
    padding-bottom: 10px;
  }
  .b-table-sticky-header {
    border-radius: 0 !important;
  }
  .form-control-plaintext,
  .col-form-label {
    padding: 0.175rem !important;
  }

  .spinner-center {
    display: flex;
    justify-content: center;
  }
  .form-group {
    margin-bottom: 0 !important;
  }
  .table td {
    background: white !important;
  }

  .b-badge {
    padding: 10px;
    font-size: 14px;
    border-radius: 4px;
  }
</style>
